<script setup lang="ts">
import { QSpinnerBall } from "quasar";

defineProps<{ size?: string }>();
</script>
<template>
  <q-spinner-ball class="medicus-loading-ball" :size="size" />
</template>
